import * as cr from "./_cr";
import * as cs from "./_ca";
import * as hf from "./_hf";
import * as ht from "./_ht";

import { useMdlz } from "./_csMdl";
import { a } from "./_csAbt";

import * as BoxC from "./_ccbBoxC";
import * as BtnC from "./_cccBtnC";
import * as TextC from "./_ccbTextC";

export const useCfmz = () => {
  const _sMdlz = useMdlz();
//  const _abtType = 'nmlz';
//  const _abtz = cs.mdlMsgAbtz[_abtType] ? cs.mdlMsgAbtz[_abtType]() : {} as ht.dz;

  const _show = (pz: {
    abtType?: ht.s,
    pfx: ht.s,
    ls?: ht.ls,
    onPrs?: (_n: ht.n) => void,
  }) => {
    const _dw = cr.d('p') ? 60 : 40;
    const _ls = pz.ls ?? [
      { key: 1, pfx: 'はい' },
      { key:-1, pfx: 'いいえ' }
    ];
    _sMdlz.set({
      bShow: true,
      oClds: [
        cr.c(BoxC.N, {
          key: -10,
//          boxStlz: _abtz.boxStlz,
          boxStlz: a(`br/1 dw/${_dw} dhx/70 fd/csc p/1 sc/lt1`),
          oClds: [
            cr.c(TextC.N, {
              key: -10,
              textz: {
                pfx: pz.pfx,
                stlz: {
                  ... a('tc/lt9'),
                },
                ptyz: {
                  ... a("tn/10"),
                },
              },
              boxStlz: {
                ... a("dw/f fd/csc fw/w"),
              },
            }),
            cr.c(BoxC.N, {
              key: -20,
              boxStlz: a('dw/f fd/rac mt/2 mb/0.5'),
              oClds: _ls.map((_dz: ht.dz, _idx: ht.n) => {
                return (
                  cr.c(BtnC.N, {
                    key: _idx,
                    boxStlz: a('br/2 dw/18 fd/ccc ph/1 pv/0.5 sc/lt5'),
                    lblCz: {
                      textz: {
                        pfx: _dz.pfx,
                        stlz: a('tb tc/lt1'),
                      },
                    },
                    pslPtyz: {
                      onPress: () => {
                        _sMdlz.set({
                          bShow: false,
                        });
                        if (pz.onPrs) pz.onPrs(_dz.key);
                      },
                    },
                  })
                )
              })
            })
          ],
        })
      ]
    })
  }

  return {
    show: _show
  }
};
